module.exports = __webpack_public_path__ + "img/pencil.85bc52a6.svg";